// extracted by mini-css-extract-plugin
export default {"c-selectedDayMessage":"day-picker-selected-day_c-selectedDayMessage__ac66f"};